/* eslint-disable */
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import axios from "axios";
import FeaturesSlider from './FeaturesSlider';

export default {
  initForm() {
    const asyncForm = document.querySelectorAll("[data-async]");

    for (let i = 0; i < asyncForm.length; i++) {
      asyncForm[i].addEventListener("submit", function (e) {
        e.preventDefault();
        const $form = this;
        const formData = new FormData($form);
        const options = {
          method: $form.dataset.method,
          headers: { "content-type": "application/x-www-form-urlencoded" },
          data: formData,
          url: $form.dataset.action,
        };
        const recaptchaInput = $form.querySelector('.hiddenRecaptcha');
        let valid = false;

        if(recaptchaInput) {
          const recaptchaValue = recaptchaInput.value;
          if(recaptchaValue != "") {
            valid = true;
          } else {
            valid = false;
          }
        } else {
          valid = true;
        }        
        
        if(valid) {
          $form.classList.add("is-loading");
          axios(options)
            .then((response) => {
              console.log("Success response:", response.data);
              if (response.data.status === "load-posts") {
                setTimeout(function () {
                  $form.classList.remove("is-loading");
                  showProducts($form, response.data);
                }, 1000);
              } else if (response.data.status === "badfields") {
                setTimeout(function () {
                  $form.classList.remove("is-loading");
                  badFields($form, response.data);
                }, 500);
              } else if (response.data.status === "success") {
                if ($form.classList.contains("cookie__form")) {
                  $form.closest(".cookie").classList.remove("is-shown");
                } else {
                  setTimeout(function () {
                    $form.classList.remove("is-loading");
                    showMessage($form, response.data);
                    gaEvent($form);
                  }, 1000);
                }
              } else if (response.data.status === "error") {
                setTimeout(function () {
                  $form.classList.remove("is-loading");
                  showMessage($form, response.data);
                }, 1000);
              }
            })
            .catch((error) => {
              console.log("Error response:", error);
            });
        }
      });
    }

    const badFields = (f, resp) => {
      resp.fields.map((field, i) => {
        const targetField = f.querySelector(`[name="${field.name}"]`);
        const targetContainer = targetField.closest(".form-input");
        targetContainer.querySelector(".form-input__field-message").innerHTML =
          field.errorMessage;
        targetContainer.classList.add("form-input--has-error");
      });
    };

    const showMessage = (f, resp) => {
      const modal = document.getElementById('response-modal');
      const close = modal.querySelector('.js-close-modal');
      const title = document.getElementById('response-title');
      const subtitle = document.getElementById('response-subtitle');
      close.addEventListener('click', () => {
        modal.classList.remove('modal--show');
      })
      title.innerHTML = resp.output.title;
      subtitle.innerHTML = resp.output.subtitle;
      if (resp.status === "success") {
        modal.classList.remove('modal--error');
        modal.classList.add('modal--show');
        modal.classList.remove( 'trial', 'contact' );
        modal.classList.add( resp.output.type );
        setTimeout(function () {
          resetForm(f);
        }, 2000);
      }
      if (resp.status === "error") {
        modal.classList.add('modal--error');
        modal.classList.add('modal--show');
      }
    };

    const gaEvent = (f) => {
      let formtype = f.dataset.formtype;
      if (typeof formtype !== 'undefined' && typeof gtag !== 'undefined') {
        gtag('event', 'screen_view', { 'app_name': 'form','screen_name': formtype });
        console.log(formtype);
      }
    };

    const showProducts = (f, resp) => {
      const container = document.getElementById('features-holder');
      const pagaValue = f.querySelector('[name="page"]');

      pagaValue.value = +pagaValue.value + 1;

      resp.data.forEach(post => {
        container.insertAdjacentHTML('beforeend', post);
      })

      if(resp.current_page === resp.total_pages) {
        f.remove();
      }

      const newBlocks = container.querySelectorAll('.features__slider');
      newBlocks.forEach(block => {
        if(!block.classList.contains('swiper-container-initialized')) {
          FeaturesSlider.init(block);
        }
      })

    }

    const resetForm = (f) => {
      const inputs = f.querySelectorAll(".form-input");
      const textareas = f.querySelectorAll("textarea");
      const containers = document.querySelectorAll(".js-select-container");
      const reInputs = f.querySelectorAll(".hiddenRecaptcha");

      if (reInputs.length > 0) {
        reInputs.forEach((input) => {
          input.value = "";
        });
      }

      if (containers.length > 0) {
        containers.forEach((container) => {
          const selectors = container.querySelectorAll(".js-select");

          selectors.forEach((selector) => {
            selector.classList.remove("is-selected");
          });
        });
      }

      f.reset();
      for (let i = 0; i < textareas.length; i++) {
        textareas[i].style.height = 50 + "px";
      }
      for (let i = 0; i < inputs.length; i++) {
        inputs[i].classList.remove("full");
        inputs[i].classList.remove("form-input--has-error");
      }
    };
  },
  initRecaptcha() {
    var callback_cf = function(response) {
      document.getElementById('cf_hiddenRecaptcha').value = response;
    };
    var callback_tf = function(response) {
      document.getElementById('tf_hiddenRecaptcha').value = response;
    };
    var expCallback_cf = function(response) {
      document.getElementById('cf_hiddenRecaptcha').value = "";
    };
    var expCallback_tf = function(response) {
      document.getElementById('tf_hiddenRecaptcha').value = "";
    }

    if(document.getElementById('g-recaptcha-2')) {
      const siteKey = document.getElementById('g-recaptcha-2').dataset.sitekey;
      grecaptcha.render('g-recaptcha-2', {'sitekey' : siteKey, 'callback' : callback_tf, 'expired-callback': expCallback_tf});
    }

    if(document.getElementById('g-recaptcha')) {
      const siteKey = document.getElementById('g-recaptcha').dataset.sitekey;
      grecaptcha.render('g-recaptcha', {'sitekey' : siteKey, 'callback' : callback_cf, 'expired-callback': expCallback_cf});
    }
  }
};
